import { Select, Tag, Tooltip } from 'antd';
import { EcheancierVersion } from '../../../Models/EcheancierPret';

interface VersionEcheancierSelectProps {
    /** Liste des versions (hook useEcheancierPret). */
    versions: EcheancierVersion[];
    /** Version actuellement consultee. */
    version: number;
    /** Appele avec la version choisie (recharger l'echeancier). */
    onSelect: (version: number) => void;
}

/**
 * Selecteur de version d'echeancier : liste toutes les versions generees,
 * la version actuelle (derniere generee) porte le Tag "actuelle".
 * Ne s'affiche que s'il existe au moins une version.
 */
const VersionEcheancierSelect = ({ versions, version, onSelect }: VersionEcheancierSelectProps) => {
    if (!versions || versions.length === 0) return null;

    return (
        <Tooltip title="Version de l'échéancier">
            <Select
                size='small'
                style={{ minWidth: 170 }}
                value={version || undefined}
                onChange={(v) => onSelect(v)}
                options={versions.map(v => ({
                    value: v.version,
                    label: (
                        <span>
                            Version {v.version} — {v.nbLignes} lignes
                            {v.isCourant === 1 && <Tag color='#116599' style={{ marginLeft: 6 }}>actuelle</Tag>}
                        </span>
                    )
                }))}
            />
        </Tooltip>
    );
};

export default VersionEcheancierSelect;
